var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main"},[_c('div',[_c('tab',{ref:"tab",attrs:{"global":true},on:{"tabClose":_vm.tabClose}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }